var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrosIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7906 8.29526C11.7843 9.30151 11.7843 10.933 12.7906 11.9392L19.988 19.1366C20.2395 19.3882 20.2395 19.7959 19.988 20.0475C19.7365 20.299 19.3287 20.299 19.0772 20.0475L11.8798 12.85C10.8735 11.8438 9.24208 11.8438 8.23583 12.85L1.09778 19.9881C0.846263 20.2396 0.438478 20.2396 0.186964 19.9881C-0.0645502 19.7366 -0.0645509 19.3288 0.186964 19.0773L7.32502 11.9392C8.33126 10.933 8.33126 9.30151 7.32502 8.29526L0.189036 1.15928C-0.0624787 0.907764 -0.0624786 0.499979 0.189036 0.248464C0.44055 -0.00304975 0.848335 -0.00304999 1.09985 0.248464L8.23583 7.38445C9.24208 8.39069 10.8735 8.39069 11.8798 7.38445L19.0751 0.189078C19.3267 -0.0624361 19.7344 -0.0624357 19.986 0.189079C20.2375 0.440593 20.2375 0.848378 19.986 1.09989L12.7906 8.29526Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosIcon);
export default __webpack_public_path__ + "static/media/CrosIcon.ae783794bcb6bf2bc510b0eacce49c99.svg";
export { ForwardRef as ReactComponent };